import type { VoidFunctionComponent } from 'react';
import Button from '../../../generic/Button';
import { FormGroup, LabeledTextInput, LabeledPasswordInput } from '../../../generic/Forms';
import type { GemSource } from '../../../../../typings/auth';

type SourceProps = {
  source: GemSource;
  onUpdateSource: <K extends keyof GemSource>(
    member: K,
    value: GemSource[K],
  ) => void;
  onRemoveSource: () => void;
};

const Source: VoidFunctionComponent<SourceProps> = ({
  source,
  onUpdateSource,
  onRemoveSource,
}) => (
  <div className="margin-bottom-sm">
    <FormGroup direction="row" spacing="sm" baselineAlignment>
      <LabeledTextInput
        label="URL"
        size="small"
        value={source.url || ''}
        onChange={value => onUpdateSource('url', value)}
        placeholder="https://github.com/org/repo"
      />
      <LabeledTextInput
        label="Username"
        size="small"
        value={source.username || ''}
        onChange={value => onUpdateSource('username', value)}
        placeholder="someuser"
      />
      <LabeledPasswordInput
        label="Password"
        size="small"
        value={source.hasPassword ? '••••••••' : source.password?.value || ''}
        onChange={value => onUpdateSource('password', { __type: 's', value })}
      />
      <Button
        type="error"
        size="small"
        onClick={onRemoveSource}
      >
        Remove
      </Button>
    </FormGroup>
  </div>
);

export default Source;
